import {CloudProvider, CloudRegion} from '../generated/graphql';

export function prettyRegion(region: CloudRegion): string {
  let cloud: string;
  switch (region.provider) {
    case CloudProvider.Aws:
      cloud = 'Amazon';
      break;
    case CloudProvider.Gcp:
      cloud = 'Google';
      break;
    case CloudProvider.Azure:
      cloud = 'Azure';
      break;
    case CloudProvider.Minio:
      cloud = 'Minio';
      break;
  }

  return `${cloud} (${region.region.toUpperCase()})`;
}
